const cartoes = {
  DEBITO: 1,
  CREDITO: 2,
  PIX: 3
}

export const CARTAO = cartoes